import React, { useState, useEffect, useRef } from "react";
import { Button } from "@twioku/common_components";
import { LineLinkShare } from "../components/LineLinkShare_V2";
import { useNavigate } from "react-router-dom";
import { Path } from "../routes/PagePath";
import { useNewAnswererInfo } from "../features/newAnswererInfo/hooks/useNewAnswererInfo";
import { useLineLinkUrl } from "../features/lineLink/hooks/useLineLink";

export const AnswererLineLinkPage: React.FC = () => {
    const navigate = useNavigate();
    const { form, answererId } = useNewAnswererInfo();
    const { data: lineLinkUrl } = useLineLinkUrl(answererId);

    const [hasSharedOrCopied, setHasSharedOrCopied] = useState(false);
    const completeButtonRef = useRef<HTMLDivElement>(null);

    const {
        watch,
        formState: { isValid },
    } = form;

    const watchedName = watch("name");

    const handleActionClicked = () => {
        setHasSharedOrCopied(true);
    };

    useEffect(() => {
        if (hasSharedOrCopied && completeButtonRef.current) {
            setTimeout(() => {
                completeButtonRef.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }, 100);
        }
    }, [hasSharedOrCopied]);

    return (
        <div className="mx-6">
            <div className="mt-8">
                <h1 className="mb-2 text-xl font-bold">
                    {watchedName}
                    さんのLINEアカウントにご利用開始案内リンクをお送りください！
                </h1>
                <div className="my-2 text-sm text-gray-500">
                    リンクから{watchedName}
                    さんにご利用案内に同意いただくことで、
                    ツイオクの利用が開始されます。
                </div>
                <div className="mx-2 flex flex-col items-center gap-4 rounded border bg-white p-4 outline-none">
                    <LineLinkShare
                        isError={!isValid}
                        onActionClicked={handleActionClicked}
                        lineLinkUrl={lineLinkUrl}
                    />
                </div>
                <h1 className="my-2 text-xl font-bold">
                    親御さまのご利用開始手順
                </h1>
                <div className="ml-2 mt-3 text-sm text-gray-600">
                    <a
                        href={process.env.VITE_LINE_AUTH_FLOW_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary underline"
                    >
                        こちら
                    </a>
                    からご確認ください。
                </div>
                <div className="mx-2 mb-16 mt-3">
                    <p className="text-sm text-gray-500">
                        ※リンクには７日間の有効期限があります。
                    </p>
                </div>
                {hasSharedOrCopied && (
                    <div ref={completeButtonRef}>
                        <Button
                            type="button"
                            onClick={() => navigate(Path.root)}
                            variant="outline"
                            className="mb-8 mt-2 h-12 w-full border-gray-300 text-gray-500"
                        >
                            リンクを送ったので完了する
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};
